//angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpParamHelper, HttpResult, PollyHttpHelper } from '@app/shared';
import { RoomPropertyDto, CreateRoomRequest, UpdateRoomRequest } from '@app/catalog';

@Injectable({
    providedIn: 'root'
})
export class RoomHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(roomId: string, departmentId?: string, programId?: string, projectId?: string): HttpResult<RoomPropertyDto> 
    {
      const queryParams: Record<string, string | undefined> = {
        departmentId,
        programId,
        projectId
      }

      const params = HttpParamHelper.toHttpParams(queryParams);

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/room/${roomId}`;
            
      console.log(`GET: ${serviceUri}`); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<RoomPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders, params }));
    }

    public create(request: CreateRoomRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/room`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public update(roomId: string, request: UpdateRoomRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/program/${roomId}`;
            
      console.log(`PUT: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}